import { GetPublishMediumInfoResponse } from '../api-services/get-publish-medium-info.service';

/**
 * 掲載媒体設定画面の媒体クラス
 *
 * @export MediumInfo
 * @class MediumInfo
 */
export class MediumInfo {
  public static readonly IS_SELECTED_TRUE = 'true';
  public check: boolean;
  public mediumType: string;
  public mediumName: string;
  constructor(arg: GetPublishMediumInfoResponse['PublishMediumList'][number]) {
    this.check = MediumInfo.IS_SELECTED_TRUE === arg.IsSelected ? true : false;
    this.mediumType = arg.MediumType;
    this.mediumName = arg.MediumName;
  }
}
